var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadedReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/tick-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/tick-circle_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.0003 34.8337C27.7087 34.8337 34.8337 27.7087 34.8337 19.0003C34.8337 10.292 27.7087 3.16699 19.0003 3.16699C10.292 3.16699 3.16699 10.292 3.16699 19.0003C3.16699 27.7087 10.292 34.8337 19.0003 34.8337Z",
    stroke: "#3DC583",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.2705 19.0004L16.7513 23.4812L25.7288 14.5195",
    stroke: "#3DC583",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadedReport);
export default __webpack_public_path__ + "static/media/downloadedReport.de57584b3ac06c9c2eef4d050ee5e5a6.svg";
export { ForwardRef as ReactComponent };